import { GetTableLayoutTimeTable } from "../../Sections/ElementsSections/TimeTable/SectionTimeTableConsts";
import { DocColumnOption } from "../../Tools/Consts";
import { ParamSetOption } from "../../Tools/ProjectX";
import { isEmptyObject, setColor } from "../../Tools/Tools";
import { createGrid } from "../rcsgrid";

export interface Field {
  Title?: string;
  Name?: string;
  Width?: string;
  Level?: string;
  Deep?: string;
  ID?: string;
  DataType?: string;
  EditStyle?: string;
  Options?: string;
  TitleAjust?: string;
  TextAjust?: string;
  Module?: string;
  Values?: string | Array<{ text: string; id: string }>;
  Details?: string;
  AccDetails?: boolean;
  OnEdit?: string;
  OnList?: string;
  OnHint?: string;
  EditMask?: string;
  ColumnID?: string;
  OnCloseUpList?: string;
  OnGetEditStyle?: string;
  FieldName?: string;
  FilterReq?: string;
  ButtonImage?: string;
  MultiCheckSet?: string;
  ListCommand?: string;
  DetailsByReq?: (data: any) => any;
  OnListCustom?: (data: any) => Array<EditorListItem>;
  OnEditButtonClick?: (data: any) => void;
  OnDropDownList?: () => Array<{ label: string; id: string }>;
  OnDropDown?: string;
  squareColorField?: string;
  CheckField?: string;
  Type?: string;
  Image?: string;
  TitleTextStyle?: string;
  TextColor?: string;
  TitleBackColor?: string;
  BackColor?: string;
  customDefaultIcons?: CustomCheckIcons;
  DemandParams?: string;
  Design?: string;
  tag?: string | number;
}

export interface Options {
  disabled?: boolean;
  config?: boolean;
  maths?: boolean;
  details?: boolean;
  markable?: boolean;
  collapsed?: boolean;
  link?: boolean;
  redNegative?: boolean;
  forParams?: boolean;
  forTable?: boolean;
  sort?: boolean;
  filterByField?: boolean;
  proto?: boolean;
  hidden?: boolean;
  period?: boolean;
  group?: boolean;
  fixed?: boolean;
  notEdit?: boolean;
  hideInGrid?: boolean;
  hideInCard?: boolean;
  notEditing?: boolean;
}

export interface FieldInfo {
  // опции колонки
  options: Options;
  optionsInt?: string | number;
  // данные для редактора
  DataType?: string;
  EditStyle?: string;
  Values: Array<EditorListItem> | [];
  details?: string;
  hardCodeReadOnlyForEditor?: string;
  accDetails?: boolean;
  editMask?: string;
  buttonImage?: string;
  FieldName?: string;
  columnID?: string;
  demandParams?: boolean;
  Module?: string;
  Path?: string;
  // события для редактора
  onEdit?: string;
  onDropDown?: string;
  onList?: string;
  onCloseUpList?: string;
  onGetEditStyle?: string;
  detailsByReq?: (data: any) => any;
  onListCustom?: (data: any) => Array<EditorListItem>;
  onEditButtonClick?: (data: any) => void;
  // чекбокс
  checkField?: string;
  multiCheckSet?: string;
  customDefaultIcons?: CustomCheckIcons;
  // настройки для колонки таблицы
  onHint?: string;
  listCommand?: string;
  titleAjust?: string;
  textAjust?: string;
  titleBackColor?: string;
  collapseRecord?: boolean;
  squareColorField?: string;
  type?: string;
  Image?: string;
  titleTextStyle?: string;
  textColor?: string;
  design?: string;
  backColor?: string;
  // другое
  Grid?: createGrid;
}

export interface ParsedColumn {
  fieldName?: string;
  title?: string; // у объекта GetDocumentLayout название поля приходит как Title, а у объекта GetTableLayout как Name
  width?: number;
  // вложенность колонок
  level?: string | number;
  // скрытый
  hide?: boolean;
  // скрытый в таблице
  hideInGrid?: boolean;
  // скрытый в списке
  hideInCard?: boolean;
  tag?: string | number;
  fieldInfo?: FieldInfo;
}

interface JsonTableLayout {
  readonly?: string;
  Columns?: Array<Field>;
}

interface AddInfo {
  Path?: string;
  Module?: string;
  grid?: createGrid;
  widthMultiply?: number;
  docOpts?: boolean | undefined;
  inputColumns?: { title: Array<ParsedColumn> };
  collapsibleField?: string;
}

interface ListValue {
  text: string;
  id: string;
}

interface EditorListItem {
  label: string;
  id: string;
}

interface CustomCheckIcons {
  [key: string]: JSX.Element;
}

//Парсинг полей объекта запросов GetTableLayout и GetDocumentLayout
export function parseColumns(json: JsonTableLayout | GetTableLayoutTimeTable, addInfo?: AddInfo) {
  const inputColumns = addInfo?.inputColumns || { title: [] };
  if (!json.Columns || isEmptyObject(json.Columns) || json.Columns.State) {
    if (!inputColumns || inputColumns.title.length === 0) {
      return {
        title: [],
      };
    }

    return {
      title: [...inputColumns?.title],
    };
  }

  const widthMultiply = addInfo?.widthMultiply || 1;

  const filteredColumns = json.Columns.filter((value) => {
    if (value.FieldName) return true;
  });

  const jsonColumns: Array<ParsedColumn> = filteredColumns.map((value: Field) => {
    const options: Options = addInfo?.docOpts
      ? getDocOptions(value.Options || 0)
      : getParamColumnsOptions(value.Options || 0);
    const deep = value.Deep || (value.Level && parseInt(value.Deep || value.Level)) || 0;
    return {
      fieldName: value.FieldName,
      title: value.Title || value.Name, // у объекта GetDocumentLayout название поля приходит как Title, а у объекта GetTableLayout как Name
      width: (value.Width && parseInt(value.Width) * widthMultiply) || 100,
      // вложенность колонок
      level: deep,
      // скрытый
      hide: (!deep && options.hidden) || options.disabled,
      // скрытый только в таблице
      hideInGrid: options.hideInGrid || options.disabled,
      // скрытый в таблице и в списке
      hideInCard: options.hideInCard || options.disabled,
      tag: value.tag || 0,
      collapseRecord: value.FieldName === addInfo?.collapsibleField,

      fieldInfo: {
        // опции колонки
        options: options,
        optionsInt: value.Options || 0,
        // данные для редактора
        DataType: value.DataType || "",
        EditStyle: value.EditStyle || "",
        Values: (value.Values && getValues(Object.values(value.Values), Boolean(Number(value.EditStyle) & 32))) || [],
        details: value.Details || "",
        hardCodeReadOnlyForEditor: json.readonly || "",
        accDetails: value.DataType === "-1" && (value.FieldName === "D_Analitika" || value.FieldName === "C_Analitika"),
        editMask: value.EditMask || "",
        buttonImage: value.ButtonImage || "",
        FieldName: value.FieldName || "",
        columnID: value.ID || "",
        demandParams: value.DemandParams === "1",
        Module: value.Module || addInfo?.Module || "",
        Path: addInfo?.Path || "",
        // события для редактора
        onEdit: value.OnEdit || "",
        onDropDown: value.OnDropDown || "",
        onList: value.OnList || "",
        detailsByReq: value.DetailsByReq,
        onListCustom: value.OnListCustom,
        onEditButtonClick: value.OnEditButtonClick,
        onCloseUpList: value.OnCloseUpList || "",
        onGetEditStyle: value.OnGetEditStyle || "",
        // чекбокс
        checkField: value.CheckField || "",
        multiCheckSet: value.MultiCheckSet || "",
        customDefaultIcons: value.customDefaultIcons,
        // настройки для колонки таблицы
        onHint: value.OnHint || "",
        listCommand: value.ListCommand || "",
        titleAjust: value.TitleAjust || "0",
        textAjust: value.TextAjust || "0",
        collapseRecord: value.FieldName === addInfo?.collapsibleField,
        squareColorField: value.squareColorField || "",
        type: value.Type || "",
        Image: value.Image || "",
        titleTextStyle: value.TitleTextStyle || "",
        textColor: value.TextColor || "",
        design: value.Design || "",
        titleBackColor: value.TitleBackColor && setColor(value.TitleBackColor),
        backColor: setColor(value.BackColor || "") || null,
        // другое
        Grid: addInfo?.grid,
      },
    };
  });

  if (inputColumns?.title.length === 0) {
    return {
      title: [...jsonColumns],
    };
  }

  return {
    title: [...inputColumns.title, ...jsonColumns],
  };
}

export function getValues(arr: Array<ListValue | string>, checklist: boolean) {
  return arr.map((item, index) => {
    if (typeof item !== "object") {
      if (checklist) {
        return { label: item, id: `${Math.pow(2, index)}` };
      }
      return { label: item, id: `${index}` };
    }
    if (checklist) {
      return { label: item.text, id: `${Math.pow(2, index)}` };
    }
    return { label: item.text, id: item.id };
  });
}
/*
  Markable: 1,
  Sortable: 2,
  ReadOnly: 4,
  NotEditing: 8,
  VerticalText: 16,
  ShortObjName: 32,
  Fixed: 64,
  RedNegative: 128,
  HiddenInGrid: 256,
  HiddenInInsp: 512,
  Filterable: 1024,
  ReferencLinke: 2048,
  InParams: 4096,
  CanGroup: 8192,
  Invisible: 16384,
  Hidden: 32768,
*/

export function getDocOptions(options: number | string) {
  return {
    markable: Boolean(Number(options) & DocColumnOption.Markable),
    sort: Boolean(Number(options) & DocColumnOption.Sortable),
    readOnly: Boolean(Number(options) & DocColumnOption.ReadOnly),
    notEditing: Boolean(Number(options) & DocColumnOption.NotEditing),
    verticalText: Boolean(Number(options) & DocColumnOption.VerticalText),
    shortObjName: Boolean(Number(options) & DocColumnOption.ShortObjName),
    fixed: Boolean(Number(options) & DocColumnOption.Fixed),
    redNegative: Boolean(Number(options) & DocColumnOption.RedNegative),
    hideInGrid: Boolean(Number(options) & DocColumnOption.HiddenInGrid),
    hideInCard: Boolean(Number(options) & DocColumnOption.HiddenInInsp),
    filterByField: Boolean(Number(options) & DocColumnOption.Filterable),
    link: Boolean(Number(options) & DocColumnOption.Reference),
    inParams: Boolean(Number(options) & DocColumnOption.InParams),
    group: Boolean(Number(options) & DocColumnOption.CanGroup),
    invisible: Boolean(Number(options) & DocColumnOption.Invisible),
    hidden: Boolean(Number(options) & DocColumnOption.Hidden),
  };
}

//   Disabled = 1,
//   InConfig = 2,
//   Calculated = 4,
//   Detalization = 8,
//   Markable = 16,
//   Collapsed = 32,
//   Reference = 64,
//   RedNegative = 128,
//   Inspector = 256,
//   Grid = 512,
//   Sortable = 1024,
//   Filterable = 2048,
//   Override = 4096,
//   Hidden = 8192,
//   History = 16384,
//   CanGroup = 32768,
//   Fixed = 65536,
//   NotEdit = 131072,

export function getParamColumnsOptions(options: number | string) {
  return {
    disabled: Boolean(Number(options) & ParamSetOption.Disabled),
    config: Boolean(Number(options) & ParamSetOption.InConfig),
    maths: Boolean(Number(options) & ParamSetOption.Calculated),
    details: Boolean(Number(options) & ParamSetOption.Detalization),
    markable: Boolean(Number(options) & ParamSetOption.Markable),
    collapsed: Boolean(Number(options) & ParamSetOption.Collapsed),
    link: Boolean(Number(options) & ParamSetOption.Reference),
    redNegative: Boolean(Number(options) & ParamSetOption.RedNegative),
    forParams: Boolean(Number(options) & ParamSetOption.Inspector),
    forTable: Boolean(Number(options) & ParamSetOption.Grid),
    sort: Boolean(Number(options) & ParamSetOption.Sortable),
    filterByField: Boolean(Number(options) & ParamSetOption.Filterable),
    proto: Boolean(Number(options) & ParamSetOption.Override),
    hidden: Boolean(Number(options) & ParamSetOption.Hidden),
    period: Boolean(Number(options) & ParamSetOption.History),
    group: Boolean(Number(options) & ParamSetOption.CanGroup),
    fixed: Boolean(Number(options) & ParamSetOption.Fixed),
    notEditing: Boolean(Number(options) & ParamSetOption.NotEdit),
    hideInGrid: false,
    hideInCard: false,
  };
}
